module.exports = __webpack_public_path__ + "media/brand-story.cb020697.mp4";